import { ReactNode } from "react";
import { renderToStaticMarkup } from "react-dom/server";

//Fuction renders the react node to static markup and extracts the string of component
export const extractText = (node: ReactNode): string => {
  try {
    const htmlString = renderToStaticMarkup(<>{node}</>);
    return htmlString;
  } catch (error) {
    return "";
  }
};
